<script>
export default {
	data: () => {
		return {
			copyrightDate: new Date().getFullYear(),
			author: 'Anrealm.net',
		};
	},
};
</script>

<template>
	<div class="flex justify-center items-center text-center">
		<div class="font-mono-ui text-xs tracking-wide text-ink-muted">
			&copy; {{ copyrightDate }} {{ author }}
		</div>
	</div>
</template>

<style lang="scss" scoped></style>
